<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <v-icon left class="flex-none mr-4" :color="safeFactions.length > 0 ? 'green' : 'grey'">
        {{ safeFactions.length > 0 ? 'mdi-check-circle' : 'mdi-circle-outline' }}
      </v-icon>
      <div class="text-overline">Factions</div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <div class="text-overline">Factions</div>
      <v-sheet v-for="faction in safeFactions" :key="faction.id" color="grey lighten-4" rounded class="pa-4">
        <v-textarea solo label="Factions" v-model="faction.name" hide-details auto-grow :readonly="loading"></v-textarea>
      </v-sheet>
      <v-alert v-if="safeFactions.length === 0" type="info" text>
        No factions generated yet.
      </v-alert>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'RealmCreatorFactionsPanel',
  props: {
    // The realm object
    realm: {
      type: Object,
      required: true,
    },
    // Whether the realm is loading
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      factions: [],
    }
  },
  computed: {
    safeFactions() {
      if (!this.realm || !Array.isArray(this.realm.factions)) {
        return [];
      }
      return this.realm.factions;
    }
  },
  watch: {
    
  },
  methods: {
    
  },
};
</script>